import type { RouteObject } from 'react-router-dom';
import { paths } from '@/router/paths';
import { InboxPage } from './InboxPage';

export const workflowRoutes: RouteObject[] = [
  { path: paths.workflowInbox, element: <InboxPage /> }
];
